module.exports = __webpack_public_path__ + "static/media/shinyRareRing.340228e5.jpg";